import { InjectionToken } from '@angular/core';

export interface PersonAdminRoutes {
  readonly list: readonly string[];
  detail: (id: string) => readonly string[];
}

export const PERSON_ADMIN_ROUTES = new InjectionToken<PersonAdminRoutes>(
  'PERSON_ADMIN_ROUTES',
);
